
// 本地调试
// export const API_URL = 'http://localhost:3000'; // 你的核心API地址


// 服务端
export const API_URL = 'https://arkpro.cn'; // 你的核心API地址

import axios from "axios";

// 七牛云上传地址（华南区，根据你的区域调整）
const QINIU_UPLOAD_URL = 'https://upload-z2.qiniup.com';
export const COSURL = 'https://www.arkpro.cn'; // 读取数据下载地址前缀

export const upfile = {
    //七牛云上传文件（Vue前端版）
    uploadFile: async (token, file) => {
        try {
            // ========== 1. 前端文件校验（替代Node.js的fs/path逻辑） ==========
            // 支持的文件类型白名单
            const allowedExts = [
                'jpg', 'jpeg', 'png', 'webp',
                'mp3', 'wav', 'ogg', 'm4a',
                'mp4', 'mpeg', 'avi', 'mov', 'webm'
            ];
            // MIME类型映射（前端用File.type兜底）
            const allowedMimeTypes = {
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'png': 'image/png',
                'webp': 'image/webp',
                'mp3': 'audio/mpeg',
                'wav': 'audio/wav',
                'ogg': 'audio/ogg',
                'm4a': 'audio/mp4',
                'mp4': 'video/mp4',
                'mpeg': 'video/mpeg',
                'avi': 'video/x-msvideo',
                'mov': 'video/quicktime',
                'webm': 'video/webm'
            };

            // 校验文件是否存在（前端File对象是否有效）
            if (!(file instanceof File)) {
                throw '请选择有效的文件（必须是浏览器File对象）';
            }

            // 校验文件大小（10MB限制）
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                throw `文件大小超过限制（最大10MB），当前文件大小：${(file.size / 1024 / 1024).toFixed(2)}MB`;
            }

            // 前端解析文件名/后缀（替代Node.js的path模块）
            const fileName = file.name; // 浏览器File对象原生属性
            const fileExt = fileName.split('.').pop().toLowerCase();
            if (!allowedExts.includes(fileExt)) {
                throw `文件格式不支持，仅允许 ${allowedExts.join('、')} 格式`;
            }
            // 获取标准Content-Type
            const contentType = allowedMimeTypes[fileExt] || file.type;

            // ========== 2. 构建前端FormData（浏览器原生） ==========
            const formData = new FormData();
            // 必传：七牛云上传Token（核心）
            formData.append('token', token);
            // 必传：文件对象（七牛云默认字段名是file）
            formData.append('file', file, fileName);

            // ========== 3. 发起前端Axios上传请求 ==========
            const response = await axios.post(QINIU_UPLOAD_URL, formData, {
                headers: {
                    'Cache-Control': 'no-cache',
                    // 注释：不要手动设置Content-Type，否则会丢失boundary分隔符
                    // 'Content-Type': 'multipart/form-data' 
                },
                timeout: 60000, // 60秒超时
            });

            // 七牛云成功返回：{ key: '文件存储路径', hash: '哈希值' }
            return response.data;

        } catch (error) {
            const errMsg = error.response?.data?.error || error.message || error;
            console.error('七牛云上传失败：', errMsg);
            throw `上传参考图失败：${errMsg}，请检查网络或Token是否有效`;
        }
    },
    //获取上传token
    getuptoken: async (phone, type = 'image') => {
        try {
            const res = await axios.get(`${API_URL}/api/getQiniuToken?phone=${phone}&type=${type}`);
            if (res.data.msg == 'success') {
                const token = res.data.data.trim(); // 获取最新 Token
                console.log("本次上传凭证", token);
                return token; // 返回 Token 给调用方
            } else {
                return '';
            }
        } catch (error) {
            const errMsg = error.response?.data?.error || error.message || error;
            console.error('七牛云上传失败：', errMsg);
            throw `上传参考图失败：${errMsg}，请检查网络或Token是否有效`;
        }
    },
    // 截取视频封面 → 【截取最后一帧、无黑屏、直接返回 Blob】
    getVideoCover: async (videoUrl) => {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            // 关键1：静音（解决浏览器自动播放限制）
            video.muted = true;
            video.crossOrigin = 'anonymous';
            // 关键2：关闭视频预加载限制
            video.preload = 'auto';
            video.src = videoUrl;

            // 1. 先加载视频元数据，获取总时长
            video.onloadedmetadata = () => {
                // 🔥 核心：获取视频总时长，最后0.1秒位置（避免最后一帧黑屏）
                const lastTime = video.duration - 0.1;
                // 强制跳转到最后一帧
                video.currentTime = lastTime;
            };

            // 2. 监听跳转完成事件，确保画面加载成功
            video.onseeked = () => {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const ctx = canvas.getContext('2d');

                // 绘制最后一帧画面
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                // 转Blob并返回
                canvas.toBlob((blob) => {
                    if (blob) resolve(blob);
                    else reject(new Error('封面生成失败'));
                }, 'image/jpeg', 0.8);
            };

            // 错误监听
            video.onerror = (err) => {
                console.error('视频加载失败', err);
                reject(err);
            };
        });
    },
   
};